export default __webpack_public_path__ + "static/media/elipse-shape.f21ecdee.svg";